import { Container } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router";
import CommCard from "src/common/CommCard";
import GoBackBtn from "src/common/GoBackBtn";
import FullScreenSpinner from "src/components/Spinner/FullScreenSpinner";
import { useApiQuery } from "src/hooks/useApiQuery";
import type { IStallDetails } from "src/Types/module/fairStall/fairStallType";
import SingleStallInfo from "./SingleStallInfo";
import StallWiseExhibitor from "./StallWiseExhibitor";

const SingleStallPage = () => {
	const [status, setStatus] = useState<string>("");
	const { id } = useParams();

	const { data: stallDetails, isLoading } = useApiQuery<IStallDetails>({
		endPoint: `/api/fair/stall/${id}`,
		queryKeys: ["SingleStall", id],
	});

	if (isLoading) {
		return <FullScreenSpinner />;
	}

	return (
		<CommCard
			showCardHeader
			helmetTitle='BTTF - Single fair member information'
		>
			<Container maxWidth='xl'>
				<GoBackBtn showGoBack />
				{stallDetails && (
					<SingleStallInfo stallDetails={stallDetails} />
				)}

				<StallWiseExhibitor
					stallExhibitorInfo={stallDetails?.stallExhibitor}
				/>
			</Container>

			{/* ! Don't remove this, might needed later! */}
			{/* <Card sx={{ mt: 4 }}>
							<ApplicationTable
								isLoading={isLoading}
								stallApplications={stallDetails.stallExhibitor}
								setStatus={setStatus}
								status={status}
							/>
						</Card> */}
		</CommCard>
	);
};

export default SingleStallPage;
